import React from 'react';
import {TimelineItem} from './EntryTimeline';
import moment from 'moment';

type EntryTimelineCommentProps = {
    timelineItem: TimelineItem;
};

export const EntryTimelineComment: React.FunctionComponent<EntryTimelineCommentProps> = ({
                                                                                             timelineItem,
                                                                                         }): JSX.Element => {

    const comment = timelineItem.value.replace('<h5 class="step-name">User Comment</h5>', '').trim();
    const today = moment();
    const commentDate = moment(timelineItem.date_created_iso8601);
    const commentAge = today.diff(commentDate, 'days');
    const commentDateDisplay = (commentAge > 1) ?
        commentDate.format('MMMM Do YYYY')
        :
        commentDate.fromNow();

    return (
        <div id={`gravityflow-note-${timelineItem.id}`}
             className="list-group-item">
            <div>
                <div className="d-block pb-1">
                    <strong>{timelineItem.display_name || 'No Name'}</strong>
                    <span className="text-secondary pl-2">{commentDateDisplay}</span>
                </div>
                <div className="gravityflow-note-body"
                     dangerouslySetInnerHTML={{__html: comment}}/>
            </div>
        </div>
    );
}